import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '28283c10-85a5-43df-b5a8-8cb4145d5a79',
	[AppLanguageCodes.SK]: '28283c10-85a5-43df-b5a8-8cb4145d5a79',
	[AppLanguageCodes.DE]: '28283c10-85a5-43df-b5a8-8cb4145d5a79',
}


export const InfoboxProbe = () => {

	return (
		<MdxDiv className='info-box' articleIds={articleIds}>
		</MdxDiv>
	);
};